import { DataManagementState } from '../models/data-management.model';

const initialDataManagementState: DataManagementState = {
    companyFootprints: {},
    updateCompanyFootprint: {},
    companyInfo: {},
    updateCompanyInfo: {}
};

export default initialDataManagementState;
